var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"txt-center"},[_c('div',[_c('img',{attrs:{"src":"/static/images/empty.png","width":200,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"msg_txt"},[_vm._v("\n    "+_vm._s(_vm.acceptEmptyData.msg)+"\n  ")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-323ca801","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/empty.vue
// module id = null
// module chunks = 